import React from 'react';
import { Grid } from '@material-ui/core';
import { uploadStyles } from './styles';

const InputContent = () => {
  const styles = uploadStyles();

  return (
    <Grid container alignItems="center" justify="center" style={{ height: '100%' }}>
      <Grid item xs={12} style={{ textAlign: 'center' }}>
        <Grid item style={{ marginBottom: 10, fontWeight: 'bold' }}>Drag files here</Grid>
        <Grid item style={{ marginBottom: 10 }}>or</Grid>
        <Grid item container alignItems="center" justify="center" className={styles.uploadButton}>
          <Grid item>
            Upload Media
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default InputContent;
